/*
    Offre Bundle Vapure
    - Calcule le palier (réduction + cadeaux) selon le nombre de produits éligibles
    - Garde les cadeaux du panier synchronisés avec ce palier
    Les réductions elles-mêmes sont appliquées par les réductions automatiques Shopify.
*/
(() => {
    const cfg = window.vapureBundleConfig
    if (!cfg) return

    const GIFT_PROP = '_vapure_gift'
    const MAX_SYNC_ROUNDS = 3

    const tierFor = (count) => {
        const gifts = []
        const addGift = (id) => {
            if (!id) return
            const gift = gifts.find(g => g.id === id)
            if (gift) gift.qty += 1
            else gifts.push({ id, qty: 1 })
        }
        let discount = 0

        if (count >= 2) {
            discount = cfg.discount2
            addGift(cfg.gifts.lotus)
        }
        if (count >= 3) {
            discount = cfg.discount3
            addGift(cfg.gifts.menthe)
        }
        if (count >= 5) cfg.gifts.candles.forEach(addGift)
        else if (count >= 4) addGift(cfg.gifts.candleTier4)

        return { count, discount, gifts }
    }

    // Ligne cadeau : ajoutée par l'offre, ou produit cadeau à 0 € (même ajouté à la main)
    const isGiftLine = (item) => Boolean(item.properties && item.properties[GIFT_PROP]) ||
        Boolean(cfg.giftVariants[item.variant_id]?.free)

    const countEligible = (items) => items
        .filter(item => !isGiftLine(item) && cfg.eligibleProductIds.includes(item.product_id))
        .reduce((sum, item) => sum + item.quantity, 0)

    const postJSON = (url, body) => fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
    })

    // Variantes qui ont échoué à l'ajout (rupture...) : on ne réessaie pas en boucle
    const failedVariants = new Set()
    let running = null
    let rerun = false
    let refreshingFromSync = false
    let chainedSyncs = 0

    const runSync = async ({ refresh }) => {
        const cart = await (await fetch('/cart.js', { headers: { Accept: 'application/json' } })).json()
        const expected = new Map(
            tierFor(countEligible(cart.items)).gifts
                .filter(g => !failedVariants.has(g.id))
                .map(g => [g.id, g.qty])
        )

        let lastResponse = null
        const kept = new Set()

        for (const line of cart.items.filter(isGiftLine)) {
            let qty = 0
            if (expected.has(line.variant_id) && !kept.has(line.variant_id)) {
                qty = expected.get(line.variant_id)
                kept.add(line.variant_id)
            }
            if (line.quantity !== qty) {
                lastResponse = await postJSON('/cart/change.js', { id: line.key, quantity: qty })
            }
        }

        const toAdd = [...expected]
            .filter(([id]) => !kept.has(id))
            .map(([id, quantity]) => ({ id, quantity, properties: { [GIFT_PROP]: '1' } }))

        if (toAdd.length) {
            lastResponse = await postJSON('/cart/add.js', { items: toAdd })
            if (!lastResponse.ok) toAdd.forEach(item => failedVariants.add(item.id))
        }

        if (lastResponse && refresh && window.refreshCartContents) {
            refreshingFromSync = true
            try {
                await window.refreshCartContents(lastResponse)
            } finally {
                refreshingFromSync = false
            }
        }
        return lastResponse
    }

    // Retourne la dernière réponse fetch si le panier a été modifié, sinon null
    const syncGifts = async ({ refresh = true } = {}) => {
        if (running) {
            rerun = true
            return running
        }
        running = runSync({ refresh })
        try {
            return await running
        } finally {
            running = null
            if (rerun) {
                rerun = false
                syncGifts()
            }
        }
    }

    // Après chaque modification du panier par le thème
    window.addEventListener('updated.shopiweb.cart', () => {
        // refreshCartContents relance cet événement : on limite les resynchronisations en chaîne
        if (refreshingFromSync) {
            chainedSyncs += 1
            if (chainedSyncs > MAX_SYNC_ROUNDS) return
        } else {
            chainedSyncs = 0
        }
        syncGifts()
    })

    window.VapureBundle = { config: cfg, tierFor, countEligible, isGiftLine, syncGifts, GIFT_PROP }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => syncGifts())
    } else {
        syncGifts()
    }
})()
